import { Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router';
import { useSettingsContext } from 'src/components/settings';
import PropertyCasafariView from 'src/modules/properties/views/property-casafari-view';
import { useGetPropertyQuery } from 'src/services/properties';

export default function PropertyCasafariPage() {
  const settings = useSettingsContext();
  const { id } = useParams();
  const query = useGetPropertyQuery({ id: id! });
  const property = query.data?.property;

  const title = query.isFetched
    ? `Casafari: ${property?.type?.name} - ${property?.name}`
    : `Property #${id}`;

  if (!property) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Container maxWidth={settings.themeStretch ? false : 'xl'}>
        <PropertyCasafariView property={property} />
      </Container>
    </>
  );
}

